// tslint:disable-next-line max-line-length
// https://github.com/vmware/clarity/blob/28187afbbf375e823dd1932cca4d6e6841e66075/src/clr-angular/data/datagrid/built-in/nested-property.ts

/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Generic accessor for deep object properties
 * that can be specified as simple dot-separated strings.
 */
export class NestedProperty<T = any> {
    private readonly splitProp: string[];

    public constructor(private readonly prop: keyof T) {
        if ((prop as string).indexOf('.') >= 0) {
            this.splitProp = (prop as string).split('.');
        }
    }

    // safe getter for a deep object property, will not throw an error but return
    // undefined if one of the intermediate properties is null or undefined.
    public getPropValue(item: T): any {
        if (this.splitProp) {
            let value: any = item;
            for (const nestedProp of this.splitProp) {
                if (value === null || typeof value === 'undefined' || typeof value[nestedProp] === 'undefined') {
                    return undefined;
                }
                value = value[nestedProp as keyof T];
            }

            return value;
        } else {
            return item[this.prop];
        }
    }
}
